import { LeftMessageComponent } from '../left-message/left-message.component';
import { openDialog, openSnackbar } from 'app/store/actions/page.action';
import { Store } from '@ngrx/store';
import { EButtonSelectItemType, IButtonSelectItem } from '../../store/models/button.model';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { IVip } from 'app/store/models/vip.model';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { InfoTipsComponent } from '../info-tips/info-tips.component';
import { DialogData } from 'app/store/models/dialog.model';
import { IReducers } from 'app/store/reducers';
import { ContactsService } from '../../store/services/contacts.service';
import { RContentComponent } from '../quick-response/r-content.component';
import { EInfoSelectItemType } from '../../store/models/select.model';
import { DIALOG_COMPONENT, DialogComponent } from '../../shared/ui/dialog/dialog.component';

@Component({
  selector: 'app-call-contact',
  templateUrl: './call-contact.component.html',
  styleUrls: ['./call-contact.component.scss'],
})
export class CallContactComponent implements OnInit {
  @Input() contact: IVip;

  infoButtonProperties: Button = {
    color: ButtonColor.BLUE,
    size: ButtonSize.SMALL,
    text: 'Reply',
  };

  infoButtonItems: IButtonSelectItem[];

  constructor(
    private store: Store<IReducers>,
    private readonly contactsService: ContactsService,
    @Inject(DIALOG_COMPONENT) private readonly dialogComponent: DialogComponent,
  ) {
  }

  leftMessageButton = () =>
    this.store.dispatch(
      openDialog({
        dialogData: {
          content: LeftMessageComponent,
          componentData: {
            contactName: this.contact.contact_firstname,
          },
          dialogMinWidth: '1000px',
          canClose: true,
          title: `VIP Call Message for ${this.contact.contact_firstname} ${this.contact.contact_lastname}`,
          onClose: dialog => {
            this.dialogComponent.close();
          },
          buttons: [
            {
              actAsClose: true,
              color: ButtonColor.RED,
              text: 'Close',
              size: ButtonSize.SMALL,
            },
            {
              color: ButtonColor.BLUE,
              text: 'Send',
              size: ButtonSize.SMALL,
              onClick: dialog => {
                if (dialog.dialogForm.valid) {
                  this.contactsService
                    .leftVipMessage(
                      this.contact.contact_id,
                      dialog.dialogForm.get('subject').value,
                      dialog.dialogForm.get('message').value,
                    )
                    .subscribe(res => {
                      this.store.dispatch(
                        openSnackbar({
                          snackbarData: {
                            data: {
                              message: 'The message has been sent',
                              type: 'success',
                              button: {
                                text: 'dismiss',
                              },
                            },
                            verticalPosition: 'bottom',
                          },
                        }),
                      );
                      dialog.closeDialog();
                    });
                }
              },
            },
          ],
        },
      }),
    );

  ngOnInit() {
    this.infoButtonItems = [
      {
        label: 'Opportunities',
        type: EInfoSelectItemType.TYPE_LINK,
        tag: 'main',
        dialogContent: this.getDialogData('opportunities'),
        onClick: () =>
          this.openDialog(this.contact.contact_id, {
            tag: 'opportunities',
            label: 'Opportunities',
            contact_email: this.contact.contact_email,
          }),
        children: [
          {
            label: 'Meetings',
            tag: 'meeting',
            type: EInfoSelectItemType.TYPE_LINK,
            dialogContent: this.getDialogData('meeting'),
            onClick: () =>
              this.openDialog(this.contact.contact_id, {
                tag: 'meeting',
                label: 'Meetings',
                contact_email: this.contact.contact_email,
              }),
          },
          {
            label: 'Order/Quote',
            tag: 'order',
            type: EInfoSelectItemType.TYPE_LINK,
            dialogContent: this.getDialogData('order'),
            onClick: () =>
              this.openDialog(this.contact.contact_id, {
                tag: 'order',
                label: 'Opportunities',
                contact_email: this.contact.contact_email,
              }),
          },
          ]
      },
      {
        label: 'Cycle',
        type: EButtonSelectItemType.TYPE_NORMAL,
        value: `/user_contacts/${this.contact.contact_id}/find_template`,
        dialogContent: this.getDialogData('cycle'),
        onClick: () =>
          this.openDialog(this.contact.contact_id, {
            tag: 'cycle',
            label: 'Cycle',
          }),
      },
      {
        label: 'Follow up',
        type: EButtonSelectItemType.TYPE_NORMAL,
        value: `/user_contacts/${this.contact.contact_id}/find_template`,
        dialogContent: this.getDialogData('follow_up'),
        onClick: () =>
          this.openDialog(this.contact.contact_id, {
            tag: 'follow_up',
            label: 'Follow Up',
            contact_email: this.contact.contact_email,
          }),
      },
      {
        label: 'Inactive',
        type: EButtonSelectItemType.TYPE_NORMAL,
        value: `/user_contacts/${this.contact.contact_id}/find_template`,
        dialogContent: this.getDialogData('inactive'),
        onClick: () =>
          this.openDialog(this.contact.contact_id, {
            tag: 'inactive',
            label: 'Inactive',
            contact_email: this.contact.contact_email,
          }),
      },
      {
        label: 'Remove',
        type: EButtonSelectItemType.TYPE_NORMAL,
        value: `/user_contacts/${this.contact.contact_id}/find_template`,
        dialogContent: this.getDialogData('remove'),
        onClick: () =>
          this.openDialog(this.contact.contact_id, {
            tag: 'remove',
            label: 'Remove',
            contact_email: this.contact.contact_email,
          }),
      },
      {
        label: 'Conversation',
        type: EButtonSelectItemType.TYPE_NORMAL,
        value: `/user_contacts/${this.contact.contact_id}/find_template`,
        dialogContent: this.getDialogData('conversation'),
        onClick: () =>
          this.openDialog(this.contact.contact_id, {
            tag: 'conversation',
            label: 'Conversation',
          }),
      },
      {
        label: 'Enter Activity',
        type: EButtonSelectItemType.TYPE_NORMAL,
        value: `/user_contacts/${this.contact.contact_id}/find_template`,
        dialogContent: this.getDialogData('enter_activity'),
        onClick: () =>
          this.openDialog(this.contact.contact_id, {
            tag: 'enter_activity',
            label: 'Inactive',
          }),
      },
    ];
  }

  openDialog(cid, data) {
    data.contact_email = this.contact.contact_email;
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: data.label,
          content: RContentComponent,
          componentData: {
            data,
            contact_id: cid,
          },
          dialogMinWidth: '1000px',
          canClose: true,
          tips: ['cycle', 'followup', 'meeting', 'inactive', 'remove'].indexOf(data.tag) !== -1 ? 'send-update' : null,
        },
      }),
    );
  }

  getDialogData(type): DialogData {
    return {
      content: InfoTipsComponent,
      title: 'Tips',
      canClose: true,
      dialogMinWidth: '700px',
      componentData: {
        type,
      },
    };
  }
}
